
import './modernizr.js'; // 'npm run modernizr' to create this file



// WEBPACK FOOTER //
// /opt/build/repo/src/vendor.ts